import React, { useState } from "react";
import { ArrowRightIcon, MenuIcon, XIcon } from "@heroicons/react/solid";

export default function Nav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-gray-900 text-gray-300 sticky top-0 z-50 border-b border-gray-800 shadow-md">
      <div className="container mx-auto flex flex-wrap p-4 flex-row items-center justify-between">
        <a
          href="#about"
          className="title-font font-bold text-white text-xl flex items-center hover:text-green-400 transition-colors"
        >
          <span className="text-green-400 mr-1">&lt;</span>
          MarkNYCweb
          <span className="text-green-400 ml-1">/&gt;</span>
        </a>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex flex-wrap items-center text-base justify-center space-x-6">
          <a
            href="#about"
            className="hover:text-white transition-colors"
          >
            About
          </a>
          <a
            href="#projects"
            className="hover:text-white transition-colors"
          >
            Projects
          </a>
          <a
            href="#skills"
            className="hover:text-white transition-colors"
          >
            Skills
          </a>
          <a
            href="#testimonials"
            className="hover:text-white transition-colors"
          >
            Testimonials
          </a>
          <a
            href="#contact"
            className="hover:text-white transition-colors"
          >
            Contact
          </a>
        </nav>

        {/* Desktop CTA Button */}
        <div className="hidden md:inline-flex items-center">
          <a
            href="#contact"
            className="inline-flex items-center bg-gray-800 border-0 py-2 px-4 focus:outline-none hover:bg-green-500 hover:text-white rounded text-base transition-colors"
          >
            Hire Me
            <ArrowRightIcon className="w-4 h-4 ml-1" />
          </a>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          onClick={toggleMobileMenu}
          aria-label="Toggle Navigation Menu"
          className="md:hidden inline-flex p-2 rounded text-gray-400 hover:text-white hover:bg-gray-800 focus:outline-none"
        >
          {mobileMenuOpen ? (
            <XIcon className="w-6 h-6" />
          ) : (
            <MenuIcon className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 pt-2 pb-4 space-y-2">
          <a
            href="#about"
            onClick={closeMobileMenu}
            className="block px-3 py-2 rounded text-base font-medium hover:text-white hover:bg-gray-800"
          >
            About
          </a>
          <a
            href="#projects"
            onClick={closeMobileMenu}
            className="block px-3 py-2 rounded text-base font-medium hover:text-white hover:bg-gray-800"
          >
            Projects
          </a>
          <a
            href="#skills"
            onClick={closeMobileMenu}
            className="block px-3 py-2 rounded text-base font-medium hover:text-white hover:bg-gray-800"
          >
            Skills
          </a>
          <a
            href="#testimonials"
            onClick={closeMobileMenu}
            className="block px-3 py-2 rounded text-base font-medium hover:text-white hover:bg-gray-800"
          >
            Testimonials
          </a>
          <a
            href="#contact"
            onClick={closeMobileMenu}
            className="block px-3 py-2 rounded text-base font-medium hover:text-white hover:bg-gray-800"
          >
            Contact
          </a>
          <a
            href="#contact"
            onClick={closeMobileMenu}
            className="block text-center mt-2 w-full bg-green-500 text-white font-medium py-2 rounded hover:bg-green-600 transition-colors"
          >
            Hire Me
          </a>
        </div>
      )}
    </header>
  );
}